module.exports = __webpack_public_path__ + "img/3.5e912030.png";